export default "__VITE_ASSET__55cd4652__"